/** Ask citations accept individual ids and inclusive ranges, including typographic dashes. */
const ITEM = String.raw`R\d+(?:\s*[-–—]\s*R\d+)?`;
export const CITE_BRACKET = String.raw`\\?\[\s*(${ITEM}(?:\s*,\s*${ITEM})*)\s*\\?\]`;
const MAX_CITATIONS_PER_GROUP = 256;

/** Bound expansion of untrusted model output; never interpret a broken range as its endpoints. */
export function citationIds(group: string): string[] {
  const ids = new Set<string>();
  for (const item of group.split(",")) {
    const match = /^\s*R(\d+)(?:\s*[-–—]\s*R(\d+))?\s*$/.exec(item);
    if (!match) continue;
    const start = Number(match[1]), end = Number(match[2] ?? match[1]);
    if (!Number.isSafeInteger(start) || !Number.isSafeInteger(end) || start < 1 || end < start || end - start >= MAX_CITATIONS_PER_GROUP) continue;
    for (let n = start; n <= end && ids.size < MAX_CITATIONS_PER_GROUP; n++) ids.add(`R${n}`);
  }
  return [...ids];
}

/** Canonicalize ranges for all clients and discard references absent from this answer. */
export function normalizeAskCitations(text: string, references: readonly { id: string }[]): string {
  const known = new Set(references.map(reference => reference.id));
  return text.replace(new RegExp(String.raw`([ \t]*)${CITE_BRACKET}`, "g"), (whole, lead: string, group: string) => {
    const all = citationIds(group);
    const kept = all.filter(id => known.has(id));
    if (!kept.length) return "";
    if (!/[-–—]/.test(group) && group.match(/R\d+/g)?.every(id => known.has(id))) return whole.replace(/\\([\[\]])/g, "$1");
    return `${lead}[${kept.join(", ")}]`;
  }).trim();
}
